import { tv } from '~/utils/tv'

export const ContentRootVariants = tv({
  base: `
    flex flex-row w-[320px] min-w-[260px] p-fourpulse gap-twopulse items-center
    border-action-border-neutral-tertiary-enabled bg-action-fill-neutral-tertiary-enabled
    rounded-pill outline-none
  `,
  variants: {
    variants: {
      title: '',
      interactive: `
        hover:border-action-border-neutral-tertiary-hovered hover:bg-action-fill-neutral-tertiary-hovered
        active:bg-action-fill-neutral-tertiary-pressed active:border-action-border-neutral-tertiary-pressed
        focus:border-halfpulse focus:border-action-border-focused
        focus:active:border-action-border-focused
      `,
    },
  },
})
